import FBLogin from "lib/fb_login";
const fblogin = new FBLogin();

export default class JangoSplash {
  constructor() {
    if (this.instance) {
      return this.instance;
    }

    this.setup_login_link();
    this.setup_events();
    this.init_round_login_module();
    this.instance = this;
    return this;
    //    const c = this.constructor;
  }

  setup_login_link() {
    $(() => {
      $("#splash_login_link").on("click, mouseenter", () => {
        this.show_and_reset_login();
        return false;
      });
    });
  }

  setup_events() {
    $(document).on("mouseenter", ".fsta_art a", function () {
      $(this).find(".olplay").removeClass("hdn");
    });

    $(document).on("mouseleave", "div.oltext", function () {
      $(this).find(".olplay").addClass("hdn");
    });

    // $(() => {
    //   $("img").lazyload();
    // });

    $(document).on("click", "#j_login_button", function () {
      $("#round_login_form").toggle();
//      $("#round_login_module img[data-original]").lazyload();

      $("#j_login_button").toggleClass("expanded");
      $("#forgot_password").hide();
      $("#login_wrap").show();
    });

    $(document).on("click", "#forgotp", function () {
      $("#forgot_password").toggle();
      $("#login_wrap").toggle();
      return false;
    });

    $(document).on("click", "#cancelforgotp", function () {
      $("#forgot_password").hide();
      $("#login_wrap").show();
      $("#fyp_message").hide();
      $("#fyp_reset_link").hide();
      $("#fyp_form").show();
      $("#user_forgot_password_email").val("");
      return false;
    });
  }

  init_round_login_module() {
    fblogin.attach_fb_login("round_fb_login");
  }

  unattach_fb_login_and_attach_email_rerequest() {
    fblogin.unattach_fb_login_and_attach_email_rerequest();
  }

  show_and_reset_login = () => {
    $("#round_login_module").fadeIn();
   // $("#round_login_module img[data-original]").lazyload();

    $("#splash_login_link").addClass("splash_highlighted_login");
    $("#forgot_password").hide();
    $("#login_wrap").show();
  };

  splash_login_overlay = () => {
    window.scrollTo(0, 0);
    this.show_and_reset_login();
    $("#j_login_button").click();
    $("#login_error").show();
  };
}
